module.exports = __webpack_public_path__ + "static/media/littlebeet-spotlight-bg.257fd6de.png";